import PropTypes from 'prop-types';
import { Box } from '@qga/roo-ui/components';
import { FormattedCreditCard } from 'components/Formatters';
import { RefundDisclaimer } from 'components/Disclaimers';
import LineItem from 'components/LineItem';
import * as propTypes from '../../propTypes';

const CreditCardLineItem = ({ total, paymentMethods }) => (
  <LineItem title="Credit card" totals={[total]}>
    {paymentMethods.map((creditCard, index) => (
      <Box key={index} aria-label="Refund to credit card">
        Refund will be made to{' '}
        <strong>
          <FormattedCreditCard cardType={creditCard.cardType} lastFourDigits={creditCard.lastFourDigits} />
        </strong>
        <RefundDisclaimer.Link />
      </Box>
    ))}
  </LineItem>
);

CreditCardLineItem.propTypes = {
  total: propTypes.total.isRequired,
  paymentMethods: PropTypes.arrayOf(propTypes.creditCardPaymentMethod).isRequired,
};

export default CreditCardLineItem;
